import React from 'react'

const LogoutIcon = (
  <>
    <path
      d="M5.5 8H15.5"
      stroke="#FF0099"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M11.5 4L15.5 8L11.5 12"
      stroke="#FF0099"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M8.5 15.5H2C1.60218 15.5 1.22064 15.342 0.93934 15.0607C0.658035 14.7794 0.5 14.3978 0.5 14V2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H8.5"
      stroke="#FF0099"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </>
)

export default LogoutIcon
